<template>
  <div class="flex flex-wrap justify-center gap-y-3 md:gap-0 sm:justify-between w-full px-4 py-2 items-center">
    <div class="text-xl font-bold w-full sm:w-auto text-center title-embargo">
      {{ title }}
    </div>
    <div class="flex flex-wrap gap-3 w-full sm:w-auto">
      <div v-if="!hiddenDefaultButton">
        <button
            v-if="entity"
            @click="$emit('updateValues', {'view': 'crear'});cleanForm();customCreateActions?.map(async action => await action());"
            :class="(isCreateHidden?'hidden ':'')+'px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none'">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
               stroke="currentColor" class="inline-block w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/>
          </svg>
          <span
              class="ml-3">Agregar {{
              entity.gender.toLowerCase() === 'f' ? 'nueva' : 'nuevo'
            }} {{ entity.value.toLowerCase() }}</span>
        </button>
        <button
            v-else
            @click="$emit('updateValues', {'view': 'volver'})"
            class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
               stroke="currentColor" class="inline-block w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
          </svg>
          <span class="ml-3">Volver</span>
        </button>
      </div>
      <slot></slot>
    </div>
    <!-- <slot></slot> -->
  </div>
</template>

<script>
/**
 * Componente de encabezado.
 * @vue/component 
 */
export default {
  name: 'HeaderComponent',
  /**
   * Propiedades del componente.
   * @prop {string} title - El título del encabezado.
   * @prop {boolean} isCreateHidden - Indica si el botón "Agregar" está oculto.
   * @prop {object} entity - La entidad a crear (opcional).
   * @prop {function} cleanForm - Función que limpia el formulario (opcional).
   * @prop {boolean} hiddenDefaultButton - Indica si el botón de acción predeterminado está oculto.
   * @prop {Array<function>} customCreateActions - Acciones personalizadas a ejecutar al hacer clic en el botón "Agregar" (opcional).
   * @emits updateValues - Se emite cuando se actualizan los valores del componente.
   */
  props: ['title', 'isCreateHidden', 'entity', 'cleanForm', 'hiddenDefaultButton', 'customCreateActions'],
  /**
   * Eventos emitidos por el componente.
   * @event updateValues
   * @param {object} payload - Un objeto que contiene la vista a actualizar.
   */
  emits: ["updateValues"]
}
</script>